import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { Search, Flame, Calendar, MessageCircle, User, Bell } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [unreadActivity, setUnreadActivity] = useState(0);
  const [rightNowCount, setRightNowCount] = useState(0);

  // Fetch notification counts
  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [messagesRes, activityRes, rightNowRes] = await Promise.all([
          axios.get(`${API}/messages/unread-count`).catch(() => ({ data: { count: 0 } })),
          axios.get(`${API}/activity/unread-count`).catch(() => ({ data: { count: 0 } })),
          axios.get(`${API}/users/right-now`).catch(() => ({ data: [] }))
        ]);
        setUnreadMessages(messagesRes.data?.count || 0);
        setUnreadActivity(activityRes.data?.count || 0);
        setRightNowCount(Array.isArray(rightNowRes.data) ? rightNowRes.data.length : 0);
      } catch (error) {
        // Silently fail - badges just won't show
      }
    };

    fetchCounts();
    // Poll every 30 seconds for updates
    const interval = setInterval(fetchCounts, 30000);
    return () => clearInterval(interval);
  }, [currentPath]);

  const isActive = (path) => {
    if (path === '/grid') return currentPath === '/grid' || currentPath === '/';
    if (path === '/right-now') return currentPath === '/right-now';
    if (path === '/events') return currentPath === '/events' || currentPath.startsWith('/events/');
    if (path === '/messages') return currentPath === '/messages' || currentPath.startsWith('/chat/');
    if (path === '/activity') return currentPath === '/activity' || currentPath === '/notifications';
    if (path === '/my-profile') return currentPath === '/my-profile' || 
      currentPath === '/safety' || currentPath === '/resources' || 
      currentPath === '/verify' || currentPath === '/blocked';
    return currentPath === path;
  };

  const navItems = [
    { path: '/grid', icon: Search, label: 'Browse', badge: 0 },
    { path: '/right-now', icon: Flame, label: 'Now', badge: rightNowCount },
    { path: '/messages', icon: MessageCircle, label: 'Chat', badge: unreadMessages },
    { path: '/activity', icon: Bell, label: 'Activity', badge: unreadActivity },
    { path: '/my-profile', icon: User, label: 'Me', badge: 0 },
  ];

  return (
    <nav className="bottom-nav z-[1000]">
      <div className="flex items-center justify-around py-3">
        {navItems.map(({ path, icon: Icon, label, badge }) => (
          <Button
            key={path}
            data-testid={`nav-${label.toLowerCase()}-btn`}
            variant="ghost"
            className={`flex flex-col items-center gap-1 relative ${
              isActive(path) ? 'text-[#FF2E63]' : 'text-[#A1A1AA] hover:text-white'
            }`}
            onClick={() => navigate(path)}
          >
            <div className="relative">
              <Icon className="w-6 h-6" />
              {badge > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-[#FF2E63] text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                  {badge > 99 ? '99+' : badge}
                </span>
              )}
            </div>
            <span className="text-xs">{label}</span>
          </Button>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
